import React, { useEffect, useState } from "react";
import { ReactComponent as Logo } from "../../../resources/images/chair.svg";
import { ReactComponent as DrugIcon } from "../../../resources/images/drug.svg";
import { ReactComponent as SyringeIcon } from "../../../resources/images/syringe.svg";
import { ReactComponent as StethIcon } from "../../../resources/images/stethoscope.svg";
import { ReactComponent as MicroIcon } from "../../../resources/images/microscope.svg";
import { ReactComponent as ArrowIcon } from "../../../resources/images/arrow.svg";
import { ReactComponent as PersonIcon } from "../../../resources/images/person.svg";
import { Link, useNavigate } from "react-router-dom";
import { api } from "../../../controllers/api";
interface Props {
  handleMenu: {
    showMenu: boolean;
    handleCloseMenu: () => void;
  };
}
function SideMenu({ handleMenu }: Props) {
  var [isOpen, setIsOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  var [categoryMenu, setCategoryMenu] = useState<
    {
      type: string;
      categories: { name: string; _id: string }[];
    }[]
  >([]);
  var [selectedCategoryMenu, setSelectedCategoryMenu] = useState<
    | {
        type: string;
        categories: { name: string; _id: string }[];
      }
    | undefined
  >(undefined);
  let handleGetMenu = async () => {
    setLoading(true);
    try {
      let res = await fetch(api + "/category-menu");
      if (res.ok) {
        let data = await res.json();
        setCategoryMenu(data);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    handleGetMenu();
  }, []);

  let handleMenuClick = (categoryMenu: {
    type: string;
    categories: { name: string; _id: string }[];
  }) => {
    setSelectedCategoryMenu(categoryMenu);
    setIsOpen(true);
  };
  return (
    <div className={"side-menu " + (handleMenu.showMenu ? "slide-in" : "")}>
      <div className={"main-view" + (isOpen ? " open" : "")}>
        {loading ? (
          <div className="types-view loader">
            <div className="shimmer-container">
              <div className="shimmer-element"></div>
            </div>
            <div className="shimmer-container">
              <div className="shimmer-element"></div>
            </div>
            <div className="shimmer-container">
              <div className="shimmer-element"></div>
            </div>
            <div className="shimmer-container">
              <div className="shimmer-element"></div>
            </div>
            <div className="shimmer-container">
              <div className="shimmer-element"></div>
            </div>
          </div>
        ) : (
          <div className="types-view">
            {categoryMenu.map((item, index) => {
              return (
                item.categories.length > 0 && (
                  <SideMenuTitle
                    handleMenuClick={handleMenuClick}
                    handleMenu={handleMenu}
                    item={item}
                  />
                )
              );
            })}
          </div>
        )}
        <div className="details-view">
          {selectedCategoryMenu && (
            <>
              <div className="details-view__header">
                <ArrowIcon onClick={() => setIsOpen(false)} />{" "}
                <h3>{selectedCategoryMenu.type}</h3>
              </div>
              <div className="details-view__categories">
                {selectedCategoryMenu.categories.map((cat) => (
                  <Link
                    to={"all?category=" + cat.name}
                    className="details-view__categories__category"
                  >
                    <p>{cat.name}</p>
                  </Link>
                ))}
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}

export default SideMenu;

const SideMenuTitle = ({
  item,
  handleMenu,
  handleMenuClick,
}: {
  item: {
    type: string;
    categories: { name: string; _id: string }[];
  };
  handleMenu: {
    showMenu: boolean;
    handleCloseMenu: () => void;
  };
  handleMenuClick: (categoryMenu: {
    type: string;
    categories: { name: string; _id: string }[];
  }) => void;
}) => {
  let [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();
  const handleNavigation = (path: string, isCategory: boolean) => {
    navigate("/all?" + (isCategory ? "category=" : "type=") + path);
    handleMenu.handleCloseMenu();
  };

  return (
    <div
      key={item.type}
      onClick={() => {
        handleMenuClick(item);
      }}
      // onClick={(e) => handleNavigation(item.type, false)}
      className="side-menu__menu-item"
    >
      <p>{item.type}</p> <ArrowIcon className={isOpen ? "open" : ""} />
      <div className="menu-options">
        {item.categories.map((cat, index) => (
          <Link to={"/all?category=" + cat.name} key={index}>
            {cat.name}
          </Link>
        ))}
      </div>
    </div>
  );
};
